var map = {
	"./demos/basic/index.ts": 48104,
	"./demos/beforeChange/index.ts": 34621,
	"./demos/disabled/index.ts": 16107,
	"./demos/onOff/index.ts": 1833,
	"./demos/size/index.ts": 37138,
	"./demos/value/index.ts": 13757,
	"./demos/widthHeight/index.ts": 9100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57654;